/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Spanish (International)
export default {
  'company-hub.carousel-extension.card-strip.card.label': 'diapositiva {positionInSet} de {setSize}',
  'company-hub.carousel-extension.carousel-content.extra-small-frame.placeholder-title': 'Añadir un título',
  'company-hub.carousel-extension.carousel-navigation.pause': 'Pausar',
  'company-hub.carousel-extension.carousel-navigation.play': 'Reproducir',
  'company-hub.carousel-extension.carousel-navigation.row-orientation.next': 'Siguiente',
  'company-hub.carousel-extension.carousel-navigation.row-orientation.previous': 'Anterior',
  'company-hub.carousel-extension.config-panel.add-frame-cta': 'Añadir marco',
  'company-hub.carousel-extension.config-panel.field.frames.error.invalid-list': 'Añadir marcos',
  'company-hub.carousel-extension.config-panel.layout.title': 'Elige un diseño',
  'company-hub.carousel-extension.config-panel.layouts.frame-above-image.label': 'Texto con marco sobre la imagen',
  'company-hub.carousel-extension.config-panel.layouts.solid-color-background.label': 'Fondo de color sólido',
  'company-hub.carousel-extension.config-panel.layouts.split-design-content.label': 'Dividir diseño',
  'company-hub.carousel-extension.config-panel.link.field.label': 'Enlace',
  'company-hub.carousel-extension.config-panel.lozenge.label.updated': 'ACTUALIZADO',
  'company-hub.carousel-extension.config-panel.navigation.progress-circles': 'Círculos de progreso',
  'company-hub.carousel-extension.config-panel.navigation.thumbnails': 'Miniaturas',
  'company-hub.carousel-extension.config-panel.preamble-link.label-v2': 'Más información sobre los carruseles',
  'company-hub.carousel-extension.config-panel.preamble-v2':
    'Diseña un conjunto de hasta {number} marcos giratorios. {supportLink}',
  'company-hub.carousel-extension.config-panel.preamble-v2-without-support-link':
    'Diseña un conjunto de hasta {number} marcos giratorios.',
  'company-hub.carousel-extension.config-panel.style.general.title': 'General',
  'company-hub.carousel-extension.config-panel.style.navigation.title': 'Navegación',
  'company-hub.carousel-extension.config-panel.styles.autoplay-label': 'Reproducción automática',
  'company-hub.carousel-extension.config-panel.styles.autoplay-tooltip-content':
    'Configurar carrusel para que se desplace automáticamente cada {number} segundos en el modo de visualización',
  'company-hub.carousel-extension.config-panel.tab.content.label': 'Contenido',
  'company-hub.carousel-extension.config-panel.tab.styles.label': 'Estilos',
  'company-hub.carousel-extension.config-panel.title': 'Carrusel',
  'company-hub.carousel-extension.description.field.label': 'Descripción',
  'company-hub.carousel-extension.description.placeholder': 'Personaliza este marco para crear un carrusel giratorio.',
  'company-hub.carousel-extension.frame-spotlight.label': 'marco {positionInSet} de {setSize}',
  'company-hub.carousel-extension.frame.background.color': 'Color de fondo',
  'company-hub.carousel-extension.frame.color-contrast.fail':
    'Los colores del texto y del fondo que has elegido no van bien para facilitar la lectura.',
  'company-hub.carousel-extension.frame.color-contrast.success':
    'Los colores del texto y del fondo que has elegido van bien para facilitar la lectura.',
  'company-hub.carousel-extension.frame.text.color': 'Color del texto',
  'company-hub.carousel-extension.hub-element.description': 'Un conjunto rotativo de bonitos marcos',
  'company-hub.carousel-extension.hub-element.title': 'Carrusel',
  'company-hub.carousel-extension.manifest.macro-description': 'Crea un trío giratorio de cuadros dinámicos.',
  'company-hub.carousel-extension.manifest.macro-title': 'Carrusel',
  'company-hub.carousel-extension.manifest.macro-title.updated': 'Carrusel [Actualizado]',
  'company-hub.carousel-extension.placeholder.description': 'Personaliza este marco para crear un carrusel giratorio.',
  'company-hub.carousel-extension.placeholder.title': 'Escribir un título para tu marco',
  'company-hub.carousel-extension.recommended.field.label': '(Recomendado)',
  'company-hub.carousel-extension.title.field.label': 'Título',
  'company-hub.carousel-extension.title.placeholder': 'Escribir un título para tu marco',
};
